







import Component, { mixins } from "vue-class-component";
import { InjectReactive } from "vue-property-decorator";
import { Call, CallStatus } from "@scrile/api-provider/dist/api/CallsProvider";
import WithAuthUser from "@/mixins/WithAuthUser";
import CallStatusViewOriginal from "@/components/CallController/components/CallStatusView/CallStatusView";
import FormatMoney from "@/components/FormatMoney";

@Component({ name: "CallStatusView", components: { FormatMoney } })
export default class CallStatusView extends mixins(CallStatusViewOriginal, WithAuthUser) {
  @InjectReactive({ from: "paidCallPrice", default: 0 })
  public readonly callPrice!: number;

  public moneyCount = 0;

  public get showMoneyCount() {
    return (this.moneyCount > 0 && this.call && this.call.receiverId === this.authUserStrict.id) || false;
  }

  public mounted() {
    let interval: number;
    let watcher = this.$watch(
      "call",
      (call: Call | null) => {
        if (call && call.status === CallStatus.ACCEPTED) {
          interval = (setInterval(() => {
            const timePassed = new Date().getTime() - new Date(call.startTime || "").getTime();
            this.moneyCount = (Math.floor(timePassed / 1000 / 60) + 1) * this.callPrice;
          }, 1000) as any) as number;
        } else {
          clearInterval(interval);
        }
      },
      { immediate: true }
    );
    this.$once("hook:beforeDestroy", () => watcher());
  }
}
